import * as React from "react";
import { ContentBlock } from "../../components/common";
import { EmailChangeForm, ProfileForm, SecurityForm } from "../../components";
import { observer } from "mobx-react";
import { useStores } from "../../stores";
import { useEffect } from "react";
import { HEADER_TYPE } from "../../constants";
import { useTranslation } from "react-i18next";

export const ProfilePage = observer(() => {
	const { settingsStore } = useStores();

	const { t } = useTranslation();

	useEffect(() => {
		settingsStore.setTypeHeader(HEADER_TYPE.RELATIVE);
	}, []);

	return (
		<>
			<ContentBlock title={t("titles.my_profile")}>
				<ProfileForm />
			</ContentBlock>

			<ContentBlock title={t("titles.security")}>
				<SecurityForm />
			</ContentBlock>

			<ContentBlock title="Email">
				<EmailChangeForm />
			</ContentBlock>
		</>
	);
});
